import * as _ from 'lodash';
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, fonts, mixins, Modal } from '@blend/consumer-components';
import { BlIcon } from '@blend/shared-react';
import { WindowWrapper } from 'login-utils/globalWrappers';
import './detailsModal.scss';

const styles = StyleSheet.create({
  header: {
    ...fonts.Gotham,
    ...mixins.borderBottom(1, 'solid', '#EDEDED'),
    ...mixins.margin(0, 25),
    alignItems: 'center',
    display: 'flex',
    fontSize: 14,
    height: 80,
    justifyContent: 'space-between',
  },
  headerLeft: {
    alignItems: 'center',
    color: colors.darkerGray,
    display: 'flex',
    fontWeight: fonts.weight.medium,
    justifyContent: 'flex-start',
    marginLeft: 25,
  },
  headerRight: {
    alignItems: 'center',
    color: colors.clayPlus3,
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: 25,
    ':hover': {
      cursor: 'pointer',
    },
  },
  brandColor: {
    color: WindowWrapper.DEPLOYMENT_CONFIG.organization.colors.action,
  },
  offsetToRight: {
    marginLeft: 12,
  },
  offsetToLeft: {
    marginRight: 12,
  },
  // required for IE flexbox bug
  modalFlexWrapper: {
    display: 'flex',
  },
  modalContent: {
    ...fonts.Gotham,
    ...mixins.margin(28, 50, 45),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minHeight: 570,
    color: colors.clayPlus4,
    fontSize: 14,
    lineHeight: '22px',
    overflow: 'auto',
  },
  modalContentTitle: {
    ...fonts.Whitney,
    fontSize: 28,
    fontWeight: fonts.weight.medium,
    lineHeight: '33px',
    marginBottom: 21,
  },
  footer: {
    ...fonts.Gotham,
    fontWeight: fonts.weight.book,
  },
});

export interface DetailsModalProps {
  isOpen: boolean;
  title: string;
  footerNotes?: string[];
  handleClose(): void;
}

export default class DetailsModal extends React.PureComponent<DetailsModalProps, any> {
  render() {
    /* istanbul ignore next */
    const { isOpen, title, children, footerNotes = [], handleClose } = this.props;
    return (
      <Modal handleClose={handleClose} contentLabel="View Details" isOpen={isOpen}>
        <div className={css(styles.header)}>
          <div className={css(styles.headerLeft)}>
            <div className={css(styles.brandColor)}>
              <BlIcon icon="info-2" />
            </div>
            <div className={css(styles.offsetToRight)}>View details</div>
          </div>
          <div onClick={handleClose}>
            <div className={css(styles.headerRight)}>
              <div className={css(styles.offsetToLeft)}>Close</div>
              <BlIcon icon="remove" />
            </div>
          </div>
        </div>
        <div className={css(styles.modalFlexWrapper)}>
          <div className={css(styles.modalContent)}>
            <div>
              <div className={css(styles.modalContentTitle)}>{title}</div>
              <div className="DetailsModal-body">{children}</div>
            </div>
            <div className={css(styles.footer)}>
              {_.map(footerNotes, (footerNote, i) => (
                <div key={i}>{footerNote}</div>
              ))}
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
